// extracted by mini-css-extract-plugin
module.exports = {"wrap":"om-z","articleImagesWrap":"pm-z","articleImage":"qm-z","singleImage":"rm-z"};